export enum ERRORS {
  BLACKLIST_FOUND = 'blacklist-found',
}
